import { StyledIcon } from "@styled-icons/styled-icon"
import classNames from "classnames"
import { ColoredIconProps } from "components/LEGACY/styled-components/Icons"
import Link from "next/link"
import { useRouter } from "next/router"
import { createElement, ReactNode } from "react"
import { StyledComponent } from "styled-components"

interface SidebarLinkProps {
  children: ReactNode
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: StyledComponent<StyledIcon, any, ColoredIconProps, never>
  href: string
  marked?: boolean
}
const TabbarLink = ({ children, href, icon, marked }: SidebarLinkProps) => {
  const router = useRouter()
  const active = router.pathname.startsWith(href)
  return (
    <>
      <style jsx>{`
        .navItem {
          display: flex;
          position: relative;
          align-items: flex-start;
          justify-content: center;
          gap: 0.5rem;
          padding: 0.5rem 1rem;
          height: 100%;
          transition: all 0.2s ease 0s;
          color: var(--dark);
          white-space: nowrap;
          text-decoration: none;
          font-size: 1rem;
        }
        .navItem:visited {
          color: var(--dark);
        }
        .navItem:hover,
        .navItem.active {
          color: var(--primary);
        }
        .navItem:hover::after,
        .navItem.active::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 0.2rem;
        }
        .navItem:hover::after {
        }
        .navItem.active::after {
          background: var(--primary);
        }
        .wrapper {
          /* flex: 1 0 auto; */
        }
      `}</style>
      <li className="wrapper">
        <Link href={href} passHref>
          <a
            {...(active ? { ["aria-current"]: "page" } : {})}
            className={classNames({ navItem: true, active: active, marked: marked })}
          >
            {icon ? createElement(icon, { size: "18", color: "currentColor", width: "18" }) : null} {children}
          </a>
        </Link>
      </li>
    </>
  )
}

export default TabbarLink
